import "./App.css"; // App.js

import React, { useEffect, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "./component/Header";
import Footer from "./component/Footer";
import BottomNav from "./component/BottomNav";
import EmailReminderBanner from "./component/EmailReminderBanner";
import NotificationPermissionPopup from "./component/NotificationPermissionPopup";
import CookieConsentPopup from "./component/CookieConsentPopup";
import Cart from "./page/Cart";
import route from "./Routes/route";
import ProtectedRoute from "./Routes/ProtectedRoute";
import ActivityIndicator from "./component/ActivityIndicator";
import { CartUIProvider, useCartUI } from "./context/CartUIContext";
import { CHUNK_RELOAD_KEY } from "./utils/chunkReloadGuard";
import { safeSessionStorage } from "./utils/safeStorage";
// import { Sitemap } from "react-router-sitemap";

function App() {
  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  }

  useEffect(() => {
    // Reaching this effect means the app mounted past any chunk-load
    // failure, so the reload guard can be armed again for the next deploy.
    safeSessionStorage.removeItem(CHUNK_RELOAD_KEY);
  }, []);

  return (
    <Router basename="/">
      <CartUIProvider>
        <ScrollToTop />
        <Header
          title={"Home"}
          Shop={"Our Stores"}
          DryFruits={"Dry Fruits"}
          Nuts={"Nuts"}
          Seeds={"Seeds"}
          Masale={"Masale"}
          All={"Wholesale Price"}
        />
        <EmailReminderBanner />
        {/* <MouseParticles
          g={1}
          color="random"
          cull=".h-100.card"
          level={6}
        /> */}
        <Suspense fallback={<ActivityIndicator />}>
          <Routes>
            {route.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  route.protected ? (
                    <ProtectedRoute><route.component /></ProtectedRoute>
                  ) : (
                    <route.component />
                  )
                }
              />
            ))}
          </Routes>
        </Suspense>
        <Footer className="fixed-footer" />
        <BottomNav />
        <CartPanel />
        <NotificationPermissionPopup />
        <CookieConsentPopup />
        {/* Generate Sitemap */}
        {/* <Sitemap routes={route} /> */}

        {/* {new Sitemap(router).build("https://zayadryfruits.com/").save("./sitemap.xml")} */}
      </CartUIProvider>
    </Router>
  );
}

function CartPanel() {
  const { cartOpen, closeCart } = useCartUI();
  return <Cart isOpen={cartOpen} onClose={closeCart} />;
}

export default App;
